export default function ArticleTemplate({ article, renderSections }) {
  return <div data-comp="ArticleTemplate">{renderSections()}</div>;
}
